import React from "react";

const PaperBG = ({ children, className = "", fullHeight = false }) => {
  return (
   
    <div

        className={`${fullHeight ? "min-h-screen" : ""} w-full text-gray-900 ${className}`}
        style={{
        backgroundColor: "#d0cbb8",
      }}
    >
      {children}
    </div>
     
  );
};

export default PaperBG;

